import { makeStyles } from '@fluentui/react-components';

export const useReportingDashboardPanelStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        gap: '4px',
        overflow: 'auto',
    },
    segmentCard: {
        padding: '12px 24px',
        overflow: 'scroll',

        '@media (max-width: 768px)': {
            padding: '8px 8px',
        },
    },
    section: {
        flex: '1 0 auto',
    },
    spinner: {
        position: 'absolute',
        minWidth: '100%',
        top: '50%',
    },
    field: {
        width: 'fit-content',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },
    row: {
        display: 'flex',
        gap: '16px',
        width: '100%',
        flexWrap: 'wrap',
    },
    infoCard: {
        display: 'flex',
        flexDirection: 'row',
        gap: '1.5rem 1rem',
        flexWrap: 'wrap',
    },
    filterInfoValue: {
        display: 'flex',
        gap: '0.25rem',
        justifyContent: 'space-around',
        alignItems: 'center',
    },
});
